import { render, staticRenderFns } from "./Brigades.vue?vue&type=template&id=4381465e&scoped=true&"
import script from "./Brigades.vue?vue&type=script&lang=js&"
export * from "./Brigades.vue?vue&type=script&lang=js&"
import style0 from "./Brigades.vue?vue&type=style&index=0&id=4381465e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381465e",
  null
  
)

export default component.exports